import { useReactiveVar } from '@apollo/client';
import { SelectChangeEvent } from '@mui/material';
import { appFormUtil } from 'modules/common';
import {
  filterInstallationsVar,
  IFilterInstallationsVar
} from 'modules/common/layer00/reactiveVariables';
import React, { useCallback } from 'react';

type IFormState = IFilterInstallationsVar;

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const initialState: IFormState = filterInstallationsVar();

export function useFormState() {
  const {
    formState,
    dispatch
  } = appFormUtil.useFormState({
    initialState: useReactiveVar(filterInstallationsVar),
    key2FieldConfig: {
      areaId: {
        label: 'Area'
      }
    }
  });



  const genFieldPropsFilterVar = useCallback(
    <TThisKey extends keyof typeof formState>(fieldKey: TThisKey) => {
      const value = formState[fieldKey];
      return {
        value: value,
        onBlur: () => dispatch({
          type: 'TRIM'
        }),
        onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent | SelectChangeEvent<unknown>) => {
          dispatch({
            type: 'UPDATE',
            payload: ({
              property: fieldKey,
              value: `${event.target.value}`
            })
          });
          if (filterInstallationsVar()[fieldKey] !== event.target.value) {
            filterInstallationsVar({
              ...filterInstallationsVar(),
              [fieldKey]: `${event.target.value}`
            });
          }
        }
      };
    },
    [
      dispatch,
      formState
    ]
  );

  const genFieldProps = genFieldPropsFilterVar;

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}
